import { get } from "lodash-es";
import { FormikErrors, FormikTouched } from "formik";
import { KycFormElementBaseLayout } from "../KycControlsBaseLayout";
import { KycInfoBox } from "../../KycInfoBox";

import "./../KycControls.scss";
import { KycFieldLock } from "../KycFieldLock";
import cn from "clsx";
import { formatDataCy } from "../../../KycUtils";
import { DataCyCompPrefix } from "../../../Kyc";
import { useKycFlow } from "../../../../../hooks/useKycFlow";
import { FieldFeedbackLabel } from "../../../../../../_metronic/_partials/controls";
import { FormikProps } from "formik/dist/types";

const getFieldCSSClasses = (
  touched: undefined | boolean | FormikTouched<any> | FormikTouched<any>[],
  errors: undefined | string | string[] | FormikErrors<any> | FormikErrors<any>[],
  values: FormikErrors<{
    [field: string]: any;
  }>
) => {
  const classes = ["form-control"];
  if (touched && errors) {
    classes.push("is-invalid");
  }
  return classes.join(" ");
};

interface KycInputProps {
  field: any;
  customHandleChange?: any;
  withFeedbackLabel: boolean;
  inline?: boolean;
  label?: string;
  props?: any;
  disabled?: boolean;
  form: FormikProps<any>;
  customFeedbackLabel?: string;
  type?: string;
  className?: string;
  classNameLabel?: string;
  infoLabel?: string;
  disableLabel?: boolean;
  locked?: boolean;
  renderAsLabel?: boolean;
  disableOnBlur?: boolean;
  onBlur?: Function;
  labelInfoLabel?: string;
}

export const KycInput = ({
  field,
  form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel = "",
  inline = true,
  type = "text",
  className = "",
  classNameLabel = "",
  disabled = false,
  infoLabel,
  disableLabel = false,
  locked = false,
  renderAsLabel = false,
  disableOnBlur = false,
  onBlur = undefined,
  labelInfoLabel = "",
  ...props
}: KycInputProps): JSX.Element => {
  const { saveField } = useKycFlow();

  const content = (
    <>
      <KycFieldLock disabled={disabled} field={field} locked={locked} renderAsLabel={renderAsLabel}>
        <input
          data-cy={formatDataCy(DataCyCompPrefix.INPUT, field?.name)}
          type={type}
          disabled={disabled}
          className={cn(
            getFieldCSSClasses(
              get(form.touched, field.name),
              get(form.errors, field.name),
              get(form.values, field.name)
            ),
            className,
            "form-control-reduce-space",
            renderAsLabel && " form-control-as-label"
          )}
          {...field}
          {...props}
          placeholder=""
          onBlur={onBlur || saveField}
        />
        {withFeedbackLabel && !disabled && (
          <FieldFeedbackLabel
            error={get(form.errors, field.name)}
            touched={get(form.touched, field.name)}
            value={field.value}
            label={label}
            type={type}
            customFeedbackLabel={customFeedbackLabel}
          />
        )}
      </KycFieldLock>
    </>
  );
  return (
    <>
      <KycFormElementBaseLayout
        labelInfoLabel={labelInfoLabel}
        className={classNameLabel}
        renderAsLabel={renderAsLabel}
        field={field}
        content={content}
        disabled={disabled}
        disableLabel={disableLabel}
        label={label}
        inline={inline}
      />
      {infoLabel && <KycInfoBox label={infoLabel} />}
    </>
  );
};
